export default {
	statusComponents,
};

function statusComponents(): object {
	return {
		nao_aprovado: {
			component: 'BadgeNaoAprovado',
		},
		aprovado: {
			component: 'BadgeAprovado',
		},
		pendente: {
			component: 'BadgePendente',
		},
	}
}
